import { FC, PropsWithChildren, useRef, useState } from 'react';
import ConfirmDialog from '../Components/Dialogs/ConfirmDialog';
import { ConfirmContext, ConfirmOptions } from './ConfirmContext';

const initialConfirmOptions: ConfirmOptions = {
    message: '',
    show: false,
    title: '',
    cancelText: '',
    confirmText: '',
    catchOnCancel: false,
};

const ConfirmContextProvider: FC<PropsWithChildren> = ({ children }) => {
    const [confirmOptions, setConfirmOptions] = useState<ConfirmOptions>(initialConfirmOptions);

    const awaitingPromiseRef = useRef<{
        resolve: () => void;
        reject: () => void;
    }>();

    const openConfirm = (options: ConfirmOptions) => {
        setConfirmOptions(options);
        return new Promise<void>((resolve, reject) => {
            awaitingPromiseRef.current = { resolve, reject };
        });
    };

    const handleConfirm = () => {
        setConfirmOptions(initialConfirmOptions);
        awaitingPromiseRef.current?.resolve();
    };

    const handleCancel = () => {
        if (confirmOptions.catchOnCancel === true && awaitingPromiseRef.current) {
            awaitingPromiseRef.current.reject();
        }
        setConfirmOptions(initialConfirmOptions);
    };

    return (
        <>
            <ConfirmContext.Provider value={openConfirm}>{children}</ConfirmContext.Provider>
            <ConfirmDialog {...confirmOptions} onCancel={handleCancel} onConfirm={handleConfirm} />
        </>
    );
};

export default ConfirmContextProvider;
